<template>
  <div class="memberData">
    <div class="mr10">
      <div class="echartBody">
        <div class="bodyTitle">地理区域</div>
        <div id="geoBar"></div>
      </div>
      <div class="echartBody mt10">
        <div class="bodyTitle">单位类型</div>
        <div id="unitBar"></div>
      </div>
    </div>
    <div class="echartBigBody mr10">
      <div class="bodyTitle">行政区域分布</div>
      <div id="province"></div>
      <div class="allMember">全国共有会员： {{ allCount }}</div>
    </div>
    <div>
      <div class="echartBody phoneTop">
        <div class="bodyTitle">学历</div>
        <div id="qualificationRing"></div>
      </div>
      <div class="echartBody mt10">
        <div class="bodyTitle">会员类型</div>
        <div id="memberTypePie"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import {
  getStatisticsRegion,
  getStatisticsCompanyType,
  getStatisticsProvince,
  getStatisticsEducation,
  getStatisticsLevel,
} from "@/api/moudles/home.js";

export default {
  name: "memberDataShow",
  data() {
    return {
      chartData: [],
      geoData: [],
      unitData: [],
      provinceData: [],
      qualificationData: [],
      memberTypeData: [],
      allCount: 0,
    };
  },
  props: {
    status: {
      type: String,
      default: "pc",
    },
  },
  mounted() {
    this.allCount = 0;
    getStatisticsRegion({
      data: {},
      success: (res) => {
        if (res.code == 0) {
          this.geoData = res.data.map((item) => {
            this.allCount += item.count;
            return {
              name: item.name,
              value: item.count,
            };
          });
        } else {
          this.geoData = [];
        }
        this.initGeoBar();
      },
    });
    getStatisticsCompanyType({
      data: {},
      success: (res) => {
        if (res.code == 0) {
          this.unitData = res.data.map((item) => {
            return {
              name: item.name,
              value: item.count,
            };
          });
        } else {
          this.unitData = [];
        }
        this.initUnitBar();
      },
    });
    getStatisticsProvince({
      data: {},
      success: (res) => {
        if (res.code == 0) {
          this.provinceData = res.data.map((item) => {
            return {
              name: item.name,
              value: item.count,
            };
          });
          const hn = this.provinceData.filter((item) => {
            return item.name === "海南省";
          });
          this.provinceData.push({
            name: "台湾省",
            value: 0,
          });
          this.provinceData.push({
            name: "南海诸岛",
            value: hn[0].value,
          });
        } else {
          this.provinceData = [];
        }
        this.initProvince();
      },
    });
    getStatisticsEducation({
      data: {},
      success: (res) => {
        if (res.code == 0) {
          this.qualificationData = res.data.map((item) => {
            return {
              name: item.name,
              value: item.count,
            };
          });
        } else {
          this.qualificationData = [];
        }
        this.initQualificationRing();
      },
    });
    getStatisticsLevel({
      data: {},
      success: (res) => {
        if (res.code == 0) {
          this.memberTypeData = res.data.map((item) => {
            return {
              name: item.name,
              value: item.count,
            };
          });
        } else {
          this.memberTypeData = [];
        }
        this.initMemberTypePie();
      },
    });
  },
  methods: {
    // 地理区域
    initGeoBar() {
      if (!document.getElementById("geoBar")) return;

      const chart = echarts.init(document.getElementById("geoBar"));
      const option = {
        grid: {
          top: 20,
          left: 30,
          right: 20,
          bottom: 40,
        },
        xAxis: {
          type: "value",
        },
        yAxis: {
          type: "category",
          data: this.geoData.map((item) => item.name),
          axisLabel: {
            show: true,
            color: "#333",
          },
        },
        dataZoom: [
          {
            type: "inside",
            yAxisIndex: 0,
          },
        ],
        series: [
          {
            type: "bar",
            label: {
              show: true,
              position: "right",
            },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                { offset: 0, color: "#83bff6" },
                { offset: 0.5, color: "#188df0" },
                { offset: 1, color: "#188df0" },
              ]),
              borderRadius: [0, 5, 5, 0],
            },
            data: this.geoData.map((item) => item.value),
          },
        ],
      };

      chart.setOption(option);
    },

    // 单位类型
    initUnitBar() {
      if (!document.getElementById("unitBar")) return;

      const chart = echarts.init(document.getElementById("unitBar"));
      const option = {
        grid: {
          top: 20,
          left: 30,
          right: 20,
          bottom: 40,
        },
        xAxis: {
          data: this.unitData.map((item) => item.name),
          axisLabel: {
            show: true,
            rotate: 45,
            color: "#333",
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          z: 10,
        },
        yAxis: {
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#999",
          },
        },
        dataZoom: [
          {
            type: "inside",
          },
        ],
        series: [
          {
            type: "bar",
            label: {
              show: true,
              position: "top",
            },
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#83bff6" },
                { offset: 0.5, color: "#188df0" },
                { offset: 1, color: "#188df0" },
              ]),
              borderRadius: [5, 5, 0, 0],
            },
            data: this.unitData.map((item) => item.value),
          },
        ],
      };

      chart.setOption(option);
    },

    // 行政区域分布
    initProvince() {
      if (!document.getElementById("province")) return;

      const chart = echarts.init(document.getElementById("province"));
      const option = {
        tooltip: {
          formatter: function (params) {
            return (
              params.seriesName + "<br />" + params.name + "：" + params.value
            );
          }, //数据格式化
        },
        visualMap: {
          min: 0,
          max: 1500,
          left: "left",
          top: "bottom",
          text: ["高", "低"], //取值范围的文字
          inRange: {
            color: ["#e0ffff", "#006edd"], //取值范围的颜色
          },
          show: true, //图注
        },
        geo: {
          map: "china",
          roam: false, //不开启缩放和平移
          zoom: 1.23, //视角缩放比例
          label: {
            normal: {
              show: true,
              fontSize: "10",
              color: "rgba(0,0,0,0.7)",
            },
          },
          itemStyle: {
            normal: {
              borderColor: "rgba(0, 0, 0, 0.2)",
            },
            emphasis: {
              areaColor: "#F3B329", //鼠标选择区域颜色
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: 20,
              borderWidth: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
        series: [
          {
            name: "信息量",
            type: "map",
            geoIndex: 0,
            data: this.provinceData,
          },
        ],
      };
      chart.setOption(option);
    },
    // 学历
    initQualificationRing() {
      if (!document.getElementById("qualificationRing")) return;

      const chart = echarts.init(document.getElementById("qualificationRing"));
      const option = {
        tooltip: {
          trigger: "item",
        },
        grid: {
          left: 0,
          top: 30,
        },
        legend: {
          type: "scroll",
          right: 10,
          top: 20,
          bottom: 20,
        },
        series: [
          {
            name: "学历",
            type: "pie",
            radius: ["40%", "70%"],
            label: {
              show: true,
              position: "inside",
              formatter: (params) => {
                return `${params.data.name}: ${params.data.value}`;
              },
            },
            labelLine: {
              show: false,
            },
            data: this.qualificationData,
          },
        ],
      };
      chart.setOption(option);
    },

    // 会员类型
    initMemberTypePie() {
      if (!document.getElementById("memberTypePie")) return;

      const chart = echarts.init(document.getElementById("memberTypePie"));
      const option = {
        tooltip: {
          trigger: "item",
        },
        legend: {
          type: "scroll",
          right: 10,
          top: 20,
          bottom: 20,
        },
        series: [
          {
            name: "Access From",
            type: "pie",
            radius: "50%",
            data: this.memberTypeData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      chart.setOption(option);
    },
  },
};
</script>

<style scoped>
.memberData {
  background-color: #c2e4ff;
  border-radius: 5px;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
}

.echartBody {
  background-color: #fff;
  width: 280px;
  height: 320px;
  border-radius: 5px;
}

.echartBigBody {
  background-color: #fff;
  width: 600px;
  height: 650px;
  border-radius: 5px;
  position: relative;
}

.allMember {
  position: absolute;
  top: 50px;
  left: 20px;
  font-size: 14px;
  color: #409eff;
}

.bodyTitle {
  line-height: 40px;
  padding-left: 20px;
  font-weight: bold;
  border-bottom: 1px solid #e5e5e5;
  position: relative;
}
.bodyTitle::before {
  content: "";
  display: inline-block;
  width: 3px;
  height: 36px;
  background-color: #d40d16;
  position: absolute;
  left: 0;
  bottom: 0;
}

.mt10 {
  margin-top: 10px;
}
.mr10 {
  margin-right: 10px;
}

#geoBar,
#unitBar,
#province,
#qualificationRing,
#memberTypePie {
  width: 100%;
  height: calc(100% - 40px);
}

@media (max-width: 768px) {
  .echartBigBody {
    display: none;
  }
  .echartBody {
    width: calc(100vw - 20px);
  }
  .phoneTop {
    margin-top: 10px;
  }
}
</style>
